<script setup lang="ts">
	const emit = defineEmits<{ (arg: 'proceed'): void }>()
	withDefaults(
		defineProps<{
			iconType?: string
			ctaText?: string
			title: string
			titleClass?: ClassContext
			desc: string
			descClass?: ClassContext
			iconDir?: string
			iconPathClass?: string
			iconSize?: {
				height?: number
				width?: number
			}
			svgClass?: string
		}>(),
		{
			iconType: 'file',
			titleClass: 'sm:text-2xl text-xl text-blue-950',
			descClass: 'text-gray-400 text-xs sm:text-base px-4'
		}
	)
</script>

<template>
	<div class="flex flex-col items-center justify-center">
		<div class="space-y-2 text-center">
			<h3 class="tracking-wide" :class="titleClass">
				{{ title }}
			</h3>
			<p class="leading-snug tracking-wide" :class="descClass">
				{{ desc }}
			</p>
		</div>
		<slot name="icon">
			<lazy-tools-icon
				:icon="iconType"
				class="my-4 block sm:my-8"
				:dir="iconDir as string"
				:path-class="`${iconPathClass} fill-gray-200`"
				:svg-class="svgClass"
				:height="iconSize?.height || 120"
				:width="iconSize?.width || 120"
			/>
		</slot>

		<a-button
			v-if="ctaText"
			class="default-btn w-full max-w-[288px] justify-center bg-primary-2"
			@click="emit('proceed')"
		>
			<slot name="cta">
				{{ ctaText }}
			</slot>
		</a-button>
		<slot />
	</div>
</template>
